var _g, _g2, _g3, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyProfileHeartCardImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 349,
    viewBox: "0 0 209 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6491 204.265C45.6562 209.502 47.023 216.921 52.6243 220.836L157.187 293.339C162.826 297.218 170.612 296.139 174.567 290.939L285.077 144.626C289.033 139.351 287.703 131.97 282.028 128.054L177.465 55.5514C171.826 51.6723 164.077 52.714 160.121 57.9881L49.6491 204.265Z",
    fill: "url(#paint0_radial_2_4421)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0127 204.542L50.014 204.541L160.486 58.2636L160.487 58.2625C164.283 53.2013 171.751 52.1762 177.204 55.9271L50.0127 204.542ZM50.0127 204.542C46.1904 209.555 47.48 216.682 52.8854 220.461C52.8857 220.461 52.886 220.461 52.8862 220.461L157.446 292.962C157.446 292.962 157.447 292.962 157.447 292.962C162.899 296.713 170.405 295.654 174.203 290.664L174.203 290.662L284.711 144.351L50.0127 204.542ZM281.767 128.43L177.206 55.9281L284.712 144.35C288.501 139.297 287.243 132.208 281.768 128.43L281.767 128.43Z",
    stroke: "url(#paint1_radial_2_4421)",
    strokeWidth: 0.914442
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0127 204.542L50.014 204.541L160.486 58.2636L160.487 58.2625C164.283 53.2013 171.751 52.1762 177.204 55.9271L50.0127 204.542ZM50.0127 204.542C46.1904 209.555 47.48 216.682 52.8854 220.461C52.8857 220.461 52.886 220.461 52.8862 220.461L157.446 292.962C157.446 292.962 157.447 292.962 157.447 292.962C162.899 296.713 170.405 295.654 174.203 290.664L174.203 290.662L284.711 144.351L50.0127 204.542ZM281.767 128.43L177.206 55.9281L284.712 144.35C288.501 139.297 287.243 132.208 281.768 128.43L281.767 128.43Z",
    stroke: "url(#paint2_radial_2_4421)",
    strokeWidth: 0.914442
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9454 212.679C76.6764 214.363 73.193 216.398 66.6056 215.423C63.6006 209.76 64.5214 205.935 65.8269 204.287C67.0958 202.602 69.676 202.55 71.1037 203.557C72.5314 204.563 72.7757 206.003 72.6136 207.549C74.0567 206.934 75.6072 206.652 77.0349 207.659C78.4261 208.629 79.2144 210.994 77.9454 212.679Z",
    fill: "#481EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2793 205.228L73.7713 205.973L73.435 202.58C73.3641 202.285 73.6975 202.103 73.9537 202.29L77.3586 204.639C77.6148 204.826 77.5748 205.157 77.2793 205.228Z",
    fill: "#481EA0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.959 196.144C174.953 199.732 187.665 192.208 192.256 186.092C196.847 179.975 194.017 171.365 188.892 167.785C183.693 164.205 178.12 165.08 172.754 167.358C173.323 161.761 172.416 156.373 167.291 152.793C162.092 149.212 152.694 149.319 148.103 155.435C143.364 161.551 139.878 175.489 150.959 196.144Z",
    fill: "#481EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.935 161.717L189.675 158.984C190.709 158.772 190.98 157.484 190.064 156.85L177.653 148.235C176.774 147.638 175.589 148.218 175.653 149.25L176.935 161.717Z",
    fill: "#481EA0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.027 128.051L177.465 55.5488C171.826 51.6697 164.077 52.7114 160.121 57.9855L49.6488 204.262C48.716 205.471 48.0766 206.829 47.7314 208.264L47.8451 207.933C48.2268 206.536 48.8662 205.177 49.7625 203.932L160.198 57.6176C164.154 52.3435 171.941 51.2653 177.542 55.1809L282.105 127.683C286.425 130.667 288.22 135.694 287.071 140.254L286.957 140.585C288.143 136.062 286.348 131.035 282.027 128.051Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2_4421",
    x: 38.4987,
    y: 44.3561,
    width: 257.708,
    height: 260.17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4289
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_4421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2_4421",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2_4421",
    x: 64.5996,
    y: 202.214,
    width: 23.5672,
    height: 24.6424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.79142,
    dy: 6.38855
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.39571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.846823 0 0 0 0 0.863998 0 0 0 0 0.954167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4421",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2_4421",
    x: 143.596,
    y: 147.994,
    width: 60.5555,
    height: 60.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.79142,
    dy: 6.38855
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.39571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.846823 0 0 0 0 0.863998 0 0 0 0 0.954167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4421",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_4421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.1045 177.275) rotate(-6.66696) scale(259.553 272.447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34591,
    stopColor: "#F4FDFF",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#C1E6FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4690D5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_4421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-13.4684 194.299) rotate(-4.13523) scale(219.148 428.172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2_4421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(341.739 147.363) rotate(171.27) scale(227.85 395.176)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#307FE2",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#307FE2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfileHeartCardImg);
export default __webpack_public_path__ + "static/media/MyProfileHeartCardImg.b356d5ca0a921522f7bc32959093c159.svg";
export { ForwardRef as ReactComponent };